import { evolve, map, path } from 'ramda';
import { createSelector } from 'reselect';
import { fullName } from '../../../common/helpers/users';
import * as barberSelector from '../../barbers/selector';
import { collectionTotal } from '../../../common/helpers/functional';

const items = path(['reports', 'breakdown']);

const getBarberName = (allBarbers, id) => fullName(allBarbers[id]) || 'Unassigned';
const mapBarbers = allBarbers => map(item => ({
  ...item,
  name: getBarberName(allBarbers, item.barberId),
}));
export const getItems = createSelector(
  [items, barberSelector.getCollection],
  (breakdownItems, allBarbers) => map(evolve({
    barbers: mapBarbers(allBarbers),
  }), breakdownItems),
);

export const getItemsTotals = createSelector(
  [getItems],
  collectionTotal,
);
